import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEqual = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 10 6",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M8.913.663H1.087a.587.587 0 100 1.174h7.826a.587.587 0 100-1.174zM8.913 3.663H1.087a.587.587 0 100 1.174h7.826a.587.587 0 100-1.174z" }) })
});
export default SvgEqual;
